import Config from './';

const routesConfig = [
  {
    path: '/config',
    component: Config,
  },
];

export default routesConfig;
